import { useQuestionCreationTaskDetails } from '@exam-management/question-creation-task-details';
import { Navigate } from '@exam-management/router';
import { QuestionCreationWorkflowStepCodeObject } from '@exam-management/task-management';
import { Outlet } from 'react-router-dom';

export default function QuestionCreationTaskQuestionManagementLayout() {
  const { status, task } = useQuestionCreationTaskDetails();

  // TODO: Just workaround to protected user who want to access create question page when task status is not in progress
  if (status.code !== QuestionCreationWorkflowStepCodeObject.QuestionCreationInProgress) {
    return <Navigate to='/access-denied' replace />;
  }

  if (!task.metadata) {
    return <Navigate to='/access-denied' replace />;
  }

  const requiredQuestionCount = task.metadata?.requirement.requiredQuestionCount ?? 0;
  const questionCreationCount = task.metadata?.requirement.questionCreationCount ?? 0;

  const reachRequiredQuestionCount = questionCreationCount >= requiredQuestionCount;

  if (reachRequiredQuestionCount) {
    return <Navigate to='/access-denied' replace />;
  }

  return <Outlet />;
}
